import { RestService, Rest, PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import {
  CalculationResultLocationLookupDto,
  GetCalculationResultPropertiesInputDto,
  CalculationResultProjectionDto,
  CalculationResultProjectionExcelDownloadDto,
  GetCalculationResultProjectionListInputDto,
  ProjectionDownloadTokenResultDto,
} from './calculation-result-projection.models';

@Injectable({
  providedIn: 'root',
})
export class CalculationResultPlanningOrchestratorService {
  private readonly restService = inject(RestService);
  private readonly apiName = 'Orchestrator';

  getProperties = (
    input: GetCalculationResultPropertiesInputDto,
    config?: Partial<Rest.Config>,
  ) =>
    this.restService.request<any, PagedResultDto<CalculationResultLocationLookupDto>>(
      {
        method: 'GET',
        url: '/api/orchestrator/planning/calculation-results/properties',
        params: { ...input, regionLocationIds: input.regionLocationIds?.join(',') },
      },
      { apiName: this.apiName, ...config },
    );

  getList = (
    input: GetCalculationResultProjectionListInputDto,
    config?: Partial<Rest.Config>,
  ) =>
    this.restService.request<any, PagedResultDto<CalculationResultProjectionDto>>(
      {
        method: 'GET',
        url: '/api/orchestrator/planning/calculation-results',
        params: input,
      },
      { apiName: this.apiName, ...config },
    );

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProjectionDownloadTokenResultDto>(
      {
        method: 'GET',
        url: '/api/orchestrator/planning/calculation-results/download-token',
      },
      { apiName: this.apiName, ...config },
    );

  getListAsExcelFile = (
    input: CalculationResultProjectionExcelDownloadDto,
    config?: Partial<Rest.Config>,
  ) =>
    this.restService.request<any, Blob>(
      {
        method: 'GET',
        responseType: 'blob',
        url: '/api/orchestrator/planning/calculation-results/excel',
        params: input,
      },
      { apiName: this.apiName, ...config },
    );
}
